<div class="header-section">
  <div class="hosp" *ngIf="hospitalName">
    <div class="hosp-icon">
      <img [src]="hospitalName?.logo" />
    </div>
    <div class="hospital-name">{{ hospitalName?.mainTitle }}</div>
  </div>

  <!-- Desktop Navigation (First 4 Logins + Dropdown) -->
  <div class="nav-links" [class.active]="isMenuOpen">
    <div
      class="login-section"
      *ngFor="
        let data of isMobileView ? headingRoutes : headingRoutes?.slice(0, 4)
      "
      (click)="onTitleClick(data)"
    >
      {{ data?.title }}
    </div>
    <!-- Doctor Details -->
    <!-- Doctor Details -->
    <div class="doctor-container" *ngIf="loginDetails">
      <div class="doctor-info" (click)="toggleDoctorDetails()">
        <img [src]="loginDetails?.imageUrl" alt="Doctor" class="doctor-image" />
      </div>

      <!-- Doctor Details Dropdown -->
      <div class="doctor-dropdown" [class.show]="isDoctorDetailsVisible">
        <div class="doctor-header">
          <div class="doctor-info">
            <p class="name">Name: {{ loginDetails?.name }}</p>
            <p class="name">Contact: {{ loginDetails?.contactNo }}</p>
            <p class="name">Type: {{ loginDetails?.type }}</p>
          </div>
        </div>
        <div class="doctor-contact"></div>
        <button class="logout-btn" (click)="logout()">Logout</button>
      </div>
    </div>

    <!-- Dropdown (Only for Desktop) -->
    <div class="dropdown" *ngIf="!isMobileView && headingRoutes?.length > 4">
      <button class="dropbtn" (click)="toggleDropdown()">More ▼</button>
      <div class="dropdown-content" [class.show]="isDropdownOpen">
        <div
          class="login-section"
          *ngFor="let data of headingRoutes?.slice(4)"
          (click)="onTitleClick(data); toggleDropdown()"
        >
          {{ data?.title }}
        </div>
      </div>
    </div>
  </div>

  <!-- Hamburger Menu (For Mobile) -->
  <div class="hamburger" (click)="toggleMenu()">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</div>
